export default "__VITE_ASSET__B6OTH85G__"